module.exports = __webpack_public_path__ + "media/KikiC.0e148a8c.mp3";